import { InvoicingConfig } from "@wingspanhq/wingspan-api-sdk";

export function getEnabledCurrencyFromConfig(config?: InvoicingConfig) {
  if (!config?.allowOnlySelectedCurrencies?.enabled) {
    return;
  }

  if (!Array.isArray(config.allowOnlySelectedCurrencies?.value)) {
    return;
  }

  return config.allowOnlySelectedCurrencies?.value[0];
}
